var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommAckRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14712_9142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9078 7.54443H29.5595C28.9105 7.54443 28.3853 8.06959 28.3853 8.71865C28.3853 9.36763 28.9104 9.89287 29.5595 9.89287H31.9078C32.5568 9.89287 33.082 9.36771 33.082 8.71865C33.082 8.06959 32.5568 7.54443 31.9078 7.54443Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0422 3.49679L18.8681 1.14844C18.5757 0.568205 17.8728 0.335471 17.2925 0.623283C16.7123 0.913361 16.4772 1.61859 16.7674 2.19883L17.9416 4.54718C18.2313 5.12507 18.933 5.36249 19.5171 5.07234C20.0972 4.78226 20.3323 4.07703 20.0422 3.49679Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7358 0.623269C27.1579 0.335457 26.4505 0.56827 26.1603 1.14842L24.9861 3.49678C24.696 4.07701 24.9311 4.78217 25.5112 5.07232C26.0971 5.36326 26.798 5.1231 27.0868 4.54717L28.261 2.19881C28.5511 1.61858 28.316 0.913347 27.7358 0.623269Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4703 7.54443H13.122C12.473 7.54443 11.9478 8.06959 11.9478 8.71865C11.9478 9.36763 12.4729 9.89287 13.122 9.89287H15.4703C16.1193 9.89287 16.6445 9.36771 16.6445 8.71865C16.6445 8.06959 16.1193 7.54443 15.4703 7.54443Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42423 19.3647H3.72744C3.079 19.3647 2.55322 19.8904 2.55322 20.539V39.3258C2.55322 39.9742 3.07892 40.5 3.72744 40.5H8.42415C9.07259 40.5 9.59837 39.9743 9.59837 39.3258V20.5389C9.59837 19.8904 9.07274 19.3647 8.42423 19.3647Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7564 22.4769C37.5493 20.6554 35.8478 19.3644 34.0146 19.3644H24.8603C25.6383 17.9714 26.0559 14.0313 26.0373 12.4218C26.0066 9.75756 23.8003 7.62256 21.136 7.62256H20.1671C19.5181 7.62256 18.9929 8.14771 18.9929 8.79678C18.9929 11.512 17.9356 16.4129 15.9417 18.407C14.5995 19.7491 13.4522 20.2354 11.9478 20.9873V38.6059C14.2511 39.3736 17.1756 40.4998 21.6332 40.4998H29.3141C31.845 40.4998 33.8161 38.1558 32.8354 35.6792C34.3295 35.2722 35.4314 33.9019 35.4314 32.2805C35.4314 31.8229 35.3431 31.3849 35.1837 30.9824C37.7016 30.2964 38.6284 27.1874 36.8808 25.2353C37.5229 24.5181 37.8769 23.537 37.7564 22.4769Z",
    fill: "#73007D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14712_9142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.166504 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommAckRate);
export default __webpack_public_path__ + "static/media/comm_ack_rate.ccacb0ad1e9725c0a714cb9146c24cd2.svg";
export { ForwardRef as ReactComponent };